import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sub-header" }
const _hoisted_2 = { class: "sub-header__info" }
const _hoisted_3 = { class: "sub-header__counters" }
const _hoisted_4 = {
  key: 2,
  class: "tariffs-info"
}
const _hoisted_5 = { class: "tariffs-info__month-title" }
const _hoisted_6 = { class: "tariffs-info__cards" }
const _hoisted_7 = { class: "tariffs-info__card-value" }
const _hoisted_8 = { class: "tariffs-info__card-label" }
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = { class: "tariffs-info__cards" }
const _hoisted_12 = ["data-qa"]
const _hoisted_13 = { class: "tariffs-info__card-value" }
const _hoisted_14 = { class: "tariffs-info__card-label" }
const _hoisted_15 = {
  key: 3,
  class: "tariffs-info__hint",
  "data-qa": "beru-tariffs-hint"
}

import VitaButton from "@/components/UI/VitaButton.vue";
import VitaInfoModal from "@/components/UI/VitaInfoModal.vue";
import VitaCounter from "@/components/VitaCounter.vue";
import VitaPopup from "@/components/VitaPopup.vue";
import VitaSearch from "@/components/VitaSearch.vue";
import VitaEmptyPlaceholder from "@/components/UI/VitaEmptyPlaceholder.vue";
import { CounterPanel, ErrorResponseData, Option } from "@/types";
import { BeruRates } from "@/types/beru";
import { computed, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { AxiosError } from "axios";
import { reachGoal } from "@/utils/metrika";


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaSubHeader',
  setup(__props) {

const store = useStore();
const route = useRoute();

const isBeruRoute = computed(() => route.path === "/beru");

const options = computed<Option[]>(() => {
  return store.getters["data/pharmacies"];
});
const option = ref<Option | undefined>();
const coreStaff = computed<CounterPanel>(() => {
  return store.getters["data/coreStaff"];
});

const holidaysFRVData = computed<CounterPanel>(() => {
  return store.getters["data/FRV_RV"];
});

const holidaysCount = computed<number>(() => {
  return (
    store.getters["data/holidays"] && store.getters["data/holidays"].length
  );
});

const setOption = () => {
  if (
    !localStorage.getItem("pharmId") ||
    store.getters["data/pharmacies"].length === 0
  ) {
    return;
  }
  const pharmId =
    localStorage.getItem("pharmId") || store.getters["data/pharmacies"][0].id;
  const pharms = store.getters["data/pharmacies"];
  const isPharmId = pharms.some((item: Option) => item.id === +pharmId);
  if (isPharmId) {
    pharms.forEach((item: Option) => {
      if (item.id === +pharmId) {
        option.value = item;
      }
    });
  } else {
    option.value = store.getters["data/pharmacies"][0];
  }
};

onBeforeMount(() => {
  setOption();
});

const hasHolidaysFRVData = computed(
  () => holidaysCount.value > 0 && holidaysFRVData.value
);

const isPopupOpen = ref(false);
const burgerButton = ref<HTMLElement | null>(null);

const togglePopup = () => (isPopupOpen.value = !isPopupOpen.value);
const closePopup = () => (isPopupOpen.value = false);

const isTariffsModalOpen = ref(false);

const openTariffsModal = () => {
  isTariffsModalOpen.value = true;
  reachGoal('beru-tariffs-click');
};

const closeTariffsModal = () => {
  isTariffsModalOpen.value = false;
};

const beruRates = computed<BeruRates[] | null>(() => {
  return store.getters["beru/beruRates"];
});

const pharmId = computed<number>(() => {
  return store.getters['data/pharmId']
})

// Карточки для модалки с тарифами (скелетон и реальные данные) итерируются по этому массиву
const tariffCards: Array<{
  label: string;
  field: keyof BeruRates;
  qaLabel: string;
}> = [
  { label: "Фикс. сумма", field: "shiftCost", qaLabel: "fix-sum" },
  { label: "Фикс. сумма - 20%", field: "mainShiftCost", qaLabel: "fix-sum-main" },
  { label: "Среднее РД", field: "shiftCostRD", qaLabel: "average-rd" },
];

const isLoading = ref(false);
const hasError = ref(false);
const loadErrorText = ref('');

// Открытие модалки с тарифами Беру
const onBeruInfoOpened = async () => {
  isLoading.value = true;
  hasError.value = false;
  loadErrorText.value = ''
  try {
    await store.dispatch("beru/getBeruRates", pharmId.value);
  } catch (e) {
    const error = e as AxiosError<ErrorResponseData>
    hasError.value = true;
    // При статус код 500 стандартный текст ошибки, при остальных из "message" в ответе
    if (error.status !== 500 && error.response?.data) {
      loadErrorText.value = error.response?.data.message
    } else {
      loadErrorText.value = 'Ошибка загрузки данных'
    }
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_Skeletor = _resolveComponent("Skeletor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (options.value.length)
        ? (_openBlock(), _createBlock(VitaSearch, {
            key: 0,
            options: options.value,
            modelValue: option.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((option).value = $event))
          }, null, 8, ["options", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sub-header__options", { 'has-hfrv': hasHolidaysFRVData.value }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (coreStaff.value)
          ? (_openBlock(), _createBlock(VitaCounter, {
              key: 0,
              title: "ФРВ",
              subtitle: "Осн.",
              "frv-type": "main",
              info: coreStaff.value
            }, null, 8, ["info"]))
          : _createCommentVNode("", true),
        (hasHolidaysFRVData.value)
          ? (_openBlock(), _createBlock(VitaCounter, {
              key: 1,
              title: "ФРВ РВ",
              "frv-type": "rv",
              info: holidaysFRVData.value,
              showIndicator: false
            }, null, 8, ["info"]))
          : _createCommentVNode("", true)
      ]),
      (isBeruRoute.value)
        ? (_openBlock(), _createBlock(VitaButton, {
            key: 0,
            class: "rounded no-shadow",
            color: "blue",
            width: "inline",
            onClick: openTariffsModal,
            "data-qa": "sub-header-button-tariffs"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Тарифы", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "burgerButton",
        ref: burgerButton,
        class: "sub-header__burger",
        onClick: togglePopup,
        "data-qa": "sub-header-burger-toggle"
      }, [
        _createVNode(_component_vita_icon, { name: "burger-menu" })
      ], 512),
      _createVNode(VitaPopup, {
        isOpen: isPopupOpen.value,
        targetRef: burgerButton.value,
        onClose: closePopup
      }, {
        default: _withCtx(() => [
          (coreStaff.value)
            ? (_openBlock(), _createBlock(VitaCounter, {
                key: 0,
                type: "secondary",
                "frv-type": "main",
                title: "ФРВ",
                subtitle: "Осн.",
                info: coreStaff.value
              }, null, 8, ["info"]))
            : _createCommentVNode("", true),
          (holidaysCount.value > 0 && holidaysFRVData.value)
            ? (_openBlock(), _createBlock(VitaCounter, {
                key: 1,
                type: "secondary",
                "frv-type": "rv",
                title: "ФРВ РВ",
                info: holidaysFRVData.value
              }, null, 8, ["info"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["isOpen", "targetRef"]),
      _createVNode(VitaInfoModal, {
        open: isTariffsModalOpen.value,
        onToggleInfoModal: closeTariffsModal,
        onOpen: onBeruInfoOpened,
        title: "Тарифы",
        "modal-icon": false,
        "modal-size": "modal-secondary modal-beru-tariffs",
        "close-on-click-outside": ""
      }, {
        default: _withCtx(() => [
          (!isLoading.value && beruRates.value && beruRates.value.length === 0)
            ? (_openBlock(), _createBlock(VitaEmptyPlaceholder, {
                key: 0,
                "qa-name": "beru-tariffs-empty",
                icon: "isEmpty",
                message: "Нет доступных тарифов",
                "icon-width": "100",
                "icon-height": "100",
                "on-refresh-click": onBeruInfoOpened
              }))
            : (!isLoading.value && hasError.value)
              ? (_openBlock(), _createBlock(VitaEmptyPlaceholder, {
                  key: 1,
                  "qa-name": "beru-tariffs-error",
                  icon: "isOffline",
                  message: loadErrorText.value,
                  description: "При загрузке данных произошла ошибка. Попробуйте обновить страницу позже.",
                  "icon-width": "100",
                  "icon-height": "100",
                  "on-refresh-click": onBeruInfoOpened
                }, null, 8, ["message"]))
              : (isLoading.value || (beruRates.value && beruRates.value.length !== 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (n) => {
                          return _createElementVNode("div", {
                            "data-qa": "beru-tariffs-shimmer",
                            key: n,
                            class: "tariffs-info__month"
                          }, [
                            _createElementVNode("h4", _hoisted_5, [
                              _createVNode(_component_Skeletor, {
                                class: "vue-skeletor-rounded-4",
                                width: "66",
                                height: "12"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tariffCards, (card) => {
                                return _createElementVNode("div", {
                                  key: card.label,
                                  class: "tariffs-info__card"
                                }, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_Skeletor, {
                                      class: "vue-skeletor-rounded-4",
                                      width: "68",
                                      height: "18"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(card.label), 1)
                                ])
                              }), 64))
                            ])
                          ])
                        }), 64))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(beruRates.value, (rates, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: rates.month,
                            class: "tariffs-info__month",
                            "data-qa": `beru-tariffs-month-${index}-block`
                          }, [
                            _createElementVNode("h4", {
                              class: "tariffs-info__month-title",
                              "data-qa": `beru-tariffs-month-${index}-title`
                            }, _toDisplayString(rates.month), 9, _hoisted_10),
                            _createElementVNode("div", _hoisted_11, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tariffCards, (card) => {
                                return _createElementVNode("div", {
                                  key: card.label,
                                  class: "tariffs-info__card",
                                  "data-qa": `beru-tariffs-month-${index}-card-${card.qaLabel}`
                                }, [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(rates[card.field] ?? "-"), 1),
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(card.label), 1)
                                ], 8, _hoisted_12)
                              }), 64))
                            ])
                          ], 8, _hoisted_9))
                        }), 128))
                  ]))
                : _createCommentVNode("", true),
          (isLoading.value || (beruRates.value && beruRates.value.length > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_vita_icon, {
                  name: "info",
                  class: "tariffs-info__hint-icon"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, "Суммы выплат указаны с учетом НДФЛ", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["open"])
    ], 2)
  ]))
}
}

})